import { Button, buttonName, Dialog, useItemNames } from '@ps-smart-cp/ppfw-client';
import { CenterAlignedButtonGroup } from './CenterAlignedButtonGroup';

interface YesNoDialogProps {
  title: string;
  message: string;
  open: boolean;
  onYes: () => void;
  onNo: () => void;
  positionTop?: string;
  positionLeft?: string;
  width?: string;
}

// ダイアログを表示するデフォルトの位置
const defaultPositionTop = '35%';
const defaultPositionLeft = '35%';
// ダイアログのデフォルトの幅
const defaultWidth = '300px';

function YesNoDialog({
  title,
  message,
  open,
  onYes,
  onNo,
  positionTop = defaultPositionTop,
  positionLeft = defaultPositionLeft,
  width = defaultWidth,
}: YesNoDialogProps) {
  const getBtnName = useItemNames(buttonName);

  return (
    <Dialog
      title={title}
      top={positionTop}
      left={positionLeft}
      width={width}
      open={open}
      renderFooter={() => (
        <CenterAlignedButtonGroup>
          <Button onClick={onYes} label={getBtnName('yes')} />
          <Button onClick={onNo} label={getBtnName('no')} />
        </CenterAlignedButtonGroup>
      )}
    >
      {message}
    </Dialog>
  );
}

export { YesNoDialog };
